import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import { useThemeStore } from '../model/theme-store';
import type { ThemeMode } from '../model/theme-store';

const options: { mode: ThemeMode; icon: typeof LightModeIcon }[] = [
  { mode: 'light', icon: LightModeIcon },
  { mode: 'dark', icon: DarkModeIcon },
  { mode: 'system', icon: SettingsBrightnessIcon },
];

export function ThemeSwitcher() {
  const { t } = useTranslation();
  const mode = useThemeStore((state) => state.mode);
  const setMode = useThemeStore((state) => state.setMode);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const active = options.find((option) => option.mode === mode) ?? options[2];
  const ActiveIcon = active.icon;

  return (
    <>
      <Tooltip title={t('theme.tooltip', { mode: t(`theme.${active.mode}`) })}>
        <IconButton
          onClick={(event) => setAnchorEl(event.currentTarget)}
          size="small"
          aria-label={t('theme.label')}
        >
          <ActiveIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {options.map(({ mode: value, icon: Icon }) => (
          <MenuItem
            key={value}
            selected={value === mode}
            onClick={() => {
              setMode(value);
              setAnchorEl(null);
            }}
          >
            <ListItemIcon>
              <Icon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t(`theme.${value}`)}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
